const RoutingPaths = {
  GENERATE: 'generate',
  SECTION_PARAM: ':sectionID',
  SHL_PARAM: ':shl',
  VIEWER: 'shlink:',
  SECTION_QUERY: 'section',
};

export default RoutingPaths;
